import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-family: ${({ theme }: { theme: Theme }) => theme.fonts.gramatika};
`;

export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: #000;
  opacity: 0.8;
`;

export const ModalContent = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 792px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalTitle = styled.p`
  width: 100%;
  margin-bottom: 16px;
  font-size: 48px;
  line-height: 140%;
  color: #fff;
  text-align: center;
`;

export const ModalBody = styled.p`
  width: 100%;
  font-size: 26px;
  line-height: 140%;
  color: #fff;
  text-align: center;
  margin-bottom: 32px;
`;

export const ModalButton = styled.button`
  background-color: transparent;
  color: #fff;
  height: 56px;
  padding: 0 32px;
  border-radius: 28px;
  border: 1px solid;
  cursor: pointer;
  font-size: 21px;
  line-height: 140%;

  &:hover {
    background-color: #ffffff11;
  }
`;
